// Yay's Beef Crisps — Product Page JS v17 FINAL

(function() {

  function initYays() {

    var section = document.getElementById('yays-product');
    if (!section) return;

    // Find pre-selected pack
    var preselected = document.querySelector('.yp-pk.yp-sel');
    var initPack = preselected ? (preselected.getAttribute('data-n') || '6') : '6';
    var initPrice = preselected ? (parseInt(preselected.getAttribute('data-price')) || 10794) : 10794;
    var initFree = preselected ? (preselected.getAttribute('data-f') === '1') : true;

    var state = {
      price: initPrice,
      qty: 1,
      mode: section.getAttribute('data-has-plans') === 'true' ? 'sub' : 'once',
      free: initFree,
      pack: initPack,
      flavor: section.getAttribute('data-flavor') || 'Original Mild',
      planId: section.getAttribute('data-plan-id') || ''
    };

    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updatePrices() {
      var base = state.price * state.qty;
      var sub = Math.round(base * 0.9);
      var shown = state.mode === 'sub' ? sub : base;
      var packQty = parseInt(state.pack) || 1;
      var perBagBase = Math.round(base / packQty);
      var perBagSub = Math.round(sub / packQty);
      var savings = Math.round(base * 0.1);

      var priceOnce = document.getElementById('yp-price-once');
      var priceOncePer = document.getElementById('yp-price-once-per');
      var priceSub = document.getElementById('yp-price-sub');
      var priceSubPer = document.getElementById('yp-price-sub-per');
      var priceSubSave = document.getElementById('yp-price-sub-save');
      var atcPrice = document.getElementById('yp-atc-price');
      var atcStrike = document.getElementById('yp-atc-strike');
      var stickyPrice = document.getElementById('yp-sticky-price');
      var stickyStrike = document.getElementById('yp-sticky-strike');
      var stickyName = document.getElementById('yp-sticky-name');

      if (priceOnce) priceOnce.textContent = fmt(base);
      if (priceOncePer) priceOncePer.textContent = fmt(perBagBase) + '/bag';
      if (priceSub) priceSub.textContent = fmt(sub);
      if (priceSubPer) priceSubPer.textContent = fmt(perBagSub) + '/bag';
      if (priceSubSave) priceSubSave.textContent = 'You save ' + fmt(savings);
      if (atcPrice) atcPrice.textContent = fmt(shown);
      if (atcStrike) {
        atcStrike.textContent = fmt(base);
        atcStrike.style.display = state.mode === 'sub' ? 'inline' : 'none';
      }
      if (stickyPrice) stickyPrice.textContent = fmt(shown);
      if (stickyStrike) {
        stickyStrike.textContent = fmt(base);
        stickyStrike.style.display = state.mode === 'sub' ? 'inline' : 'none';
      }
      if (stickyName) stickyName.textContent = state.pack + ' Pack · ' + state.flavor;
    }

    function updateShipping() {
      var sn = document.getElementById('yp-sn');
      var dlv = document.getElementById('yp-dlv');
      var perkShip = document.getElementById('yp-perk-ship');
      if (state.free) {
        if (sn) sn.classList.add('yp-show');
        if (dlv) dlv.textContent = 'Complimentary shipping included';
        if (perkShip) perkShip.style.display = 'flex';
      } else {
        if (sn) sn.classList.remove('yp-show');
        if (dlv) dlv.textContent = '';
        if (perkShip) perkShip.style.display = 'none';
      }
    }

    // === IMAGE CAROUSEL ===
    var galCur = 0;
    var galTrack = document.getElementById('yp-track');
    var galSlides = document.querySelectorAll('.yp-gal-slide');
    var galTotal = galSlides.length;
    var galStartX = 0;

    function galGoTo(i) {
      if (galTotal === 0) return;
      galCur = ((i % galTotal) + galTotal) % galTotal;
      if (galTrack) galTrack.style.transform = 'translateX(-' + (galCur * 100) + '%)';
      document.querySelectorAll('.yp-gal-dot').forEach(function(d, idx) { d.classList.toggle('yp-on', idx === galCur); });
      document.querySelectorAll('.yp-thumb').forEach(function(t, idx) { t.classList.toggle('yp-active', idx === galCur); });
    }

    var galPrev = document.getElementById('yp-gal-prev');
    var galNext = document.getElementById('yp-gal-next');
    if (galPrev) galPrev.addEventListener('click', function() { galGoTo(galCur - 1); });
    if (galNext) galNext.addEventListener('click', function() { galGoTo(galCur + 1); });

    document.querySelectorAll('.yp-gal-dot').forEach(function(d) {
      d.addEventListener('click', function() { galGoTo(parseInt(d.dataset.i)); });
    });
    document.querySelectorAll('.yp-thumb').forEach(function(t) {
      t.addEventListener('click', function() { galGoTo(parseInt(t.dataset.i)); });
    });

    var galEl = document.getElementById('yp-gal');
    if (galEl) {
      galEl.addEventListener('touchstart', function(e) { galStartX = e.touches[0].clientX; }, {passive:true});
      galEl.addEventListener('touchend', function(e) {
        var diff = galStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { galGoTo(diff > 0 ? galCur + 1 : galCur - 1); }
      }, {passive:true});
    }

    // === PACK SELECTOR ===
    document.querySelectorAll('.yp-pk').forEach(function(pk) {
      pk.addEventListener('click', function() {
        document.querySelectorAll('.yp-pk').forEach(function(p) { p.classList.remove('yp-sel'); });
        pk.classList.add('yp-sel');
        state.price = parseInt(pk.getAttribute('data-price')) || state.price;
        state.free = pk.getAttribute('data-f') === '1';
        state.pack = pk.getAttribute('data-n');
        var vidInput = document.getElementById('yp-vid');
        if (vidInput) vidInput.value = pk.getAttribute('data-vid');
        var vidInputSub = document.getElementById('yp-vid-sub');
        if (vidInputSub) vidInputSub.value = pk.getAttribute('data-vid');
        var lbl = document.getElementById('yp-lbl');
        if (lbl) lbl.textContent = state.pack + ' Pack';
        updateShipping();
        updatePrices();
      });
    });

    // === FLAVOR SELECTOR ===
    document.querySelectorAll('.yp-fl').forEach(function(fl) {
      fl.addEventListener('click', function() {
        document.querySelectorAll('.yp-fl').forEach(function(f) { f.classList.remove('yp-sel'); });
        fl.classList.add('yp-sel');
        var nameEl = fl.querySelector('.yp-fl__name');
        if (nameEl) state.flavor = nameEl.textContent;
        updatePrices();
        var url = fl.getAttribute('data-url');
        if (url && url !== '' && url !== 'nil' && url !== 'blank') {
          setTimeout(function() { window.location.href = url; }, 150);
        }
      });
    });

    // === PROTEIN TYPE TOGGLE ===
    document.querySelectorAll('.yp-type-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var type = btn.getAttribute('data-type');
        document.querySelectorAll('.yp-type-btn').forEach(function(b) { b.classList.remove('yp-type-sel'); });
        btn.classList.add('yp-type-sel');
        document.querySelectorAll('.yp-flavors').forEach(function(fl) {
          fl.style.display = (fl.getAttribute('data-type') === type) ? '' : 'none';
        });
      });
    });

    // === QUANTITY ===
    var qtyDown = document.getElementById('yp-qty-down');
    var qtyUp = document.getElementById('yp-qty-up');
    var qtyNum = document.getElementById('yp-qty');
    var qtyInput = document.getElementById('yp-quantity');

    if (qtyDown) {
      qtyDown.addEventListener('click', function() {
        state.qty = Math.max(1, state.qty - 1);
        if (qtyNum) qtyNum.textContent = state.qty;
        if (qtyInput) qtyInput.value = state.qty;
        var qtyInputSub = document.getElementById('yp-quantity-sub');
        if (qtyInputSub) qtyInputSub.value = state.qty;
        updatePrices();
      });
    }
    if (qtyUp) {
      qtyUp.addEventListener('click', function() {
        state.qty++;
        if (qtyNum) qtyNum.textContent = state.qty;
        if (qtyInput) qtyInput.value = state.qty;
        var qtyInputSub2 = document.getElementById('yp-quantity-sub');
        if (qtyInputSub2) qtyInputSub2.value = state.qty;
        updatePrices();
      });
    }

    // === PURCHASE MODE ===
    var poSub = document.getElementById('yp-po-sub');
    var poOnce = document.getElementById('yp-po-once');
    var rdotSub = document.getElementById('yp-rdot-sub');
    var rdotOnce = document.getElementById('yp-rdot-once');
    var atcBtn = document.getElementById('yp-atc');

    function setMode(m) {
      state.mode = m;
      var formSub = document.getElementById('yp-form-sub');
      var formOnce = document.getElementById('yp-form');

      if (m === 'sub' && formSub) {
        if (poSub) poSub.classList.add('yp-sel');
        if (poOnce) poOnce.classList.remove('yp-sel');
        if (rdotSub) rdotSub.classList.add('yp-on');
        if (rdotOnce) rdotOnce.classList.remove('yp-on');
        // Point ATC button to sub form
        if (atcBtn) atcBtn.setAttribute('form', 'yp-form-sub');
      } else {
        if (poOnce) poOnce.classList.add('yp-sel');
        if (poSub) poSub.classList.remove('yp-sel');
        if (rdotOnce) rdotOnce.classList.add('yp-on');
        if (rdotSub) rdotSub.classList.remove('yp-on');
        // Point ATC button to regular form
        if (atcBtn) atcBtn.setAttribute('form', 'yp-form');
      }
      updatePrices();
    }

    if (poSub) poSub.addEventListener('click', function() { setMode('sub'); });
    if (poOnce) poOnce.addEventListener('click', function() { setMode('once'); });

    // === STICKY BAR ===
    var sticky = document.getElementById('yp-sticky');
    var stickyBtn = document.getElementById('yp-sticky-btn');
    if (stickyBtn && atcBtn) {
      stickyBtn.addEventListener('click', function() { atcBtn.click(); });
    }
    if (atcBtn && sticky) {
      window.addEventListener('scroll', function() {
        var rect = atcBtn.getBoundingClientRect();
        sticky.classList.toggle('yp-show', rect.bottom < 0);
      }, { passive: true });
    }

    // === FAQ ACCORDION ===
    document.querySelectorAll('.yp-faq-q').forEach(function(q) {
      q.addEventListener('click', function() {
        var a = q.nextElementSibling;
        var ic = q.querySelector('.yp-faq-ic');
        var isOpen = a && a.classList.contains('yp-open');
        document.querySelectorAll('.yp-faq-a').forEach(function(x) { x.classList.remove('yp-open'); });
        document.querySelectorAll('.yp-faq-ic').forEach(function(x) { x.classList.remove('yp-open'); x.textContent = '+'; });
        if (!isOpen && a) { a.classList.add('yp-open'); if (ic) { ic.classList.add('yp-open'); } }
      });
    });

    // === UGC VIDEO PLAY/PAUSE ===
    document.querySelectorAll('.yp-ugc-item').forEach(function(item) {
      item.addEventListener('click', function() {
        var v = item.querySelector('video');
        var p = item.querySelector('.yp-ugc-play');
        if (!v) return;
        if (v.paused) { v.play(); if (p) p.style.display = 'none'; }
        else { v.pause(); if (p) p.style.display = 'flex'; }
      });
    });

    // === FINAL CTA SCROLL ===
    var finalCta = document.getElementById('yp-final-cta');
    if (finalCta) {
      finalCta.addEventListener('click', function() {
        var target = document.getElementById('yp-gal');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    }

    // Init
    setMode(state.mode);
    updateShipping();
    updatePrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYays);
  } else {
    initYays();
  }

})();
